import React, { useState, useEffect, useCallback } from 'react';

/**
 * Botón flotante en la esquina inferior derecha que aparece al hacer scroll
 * y lleva de regreso al inicio de la página.
 */
const BotonVolverArriba = ({ umbral = 300 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const manejarScroll = () => {
      setVisible(window.scrollY > umbral);
    };
    manejarScroll();
    window.addEventListener('scroll', manejarScroll, { passive: true });
    return () => window.removeEventListener('scroll', manejarScroll);
  }, [umbral]);

  const volverArriba = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={volverArriba}
      aria-label="Volver al inicio de la página"
      title="Volver al inicio"
      className="boton-volver-arriba"
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
        cursor: 'pointer',
        fontSize: '18px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <i className="fas fa-arrow-up"></i>
    </button>
  );
};

export default BotonVolverArriba;
